import { MouseEventHandler } from 'react';
import ImageWithFallback from '../../common/ImageWithFallback';
import type MagazineBanner from '../../../../types/MagazineBanner';

type Props = {
  banner: MagazineBanner;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  prefetch?: boolean;
};

const Card = ({ banner, onClick, prefetch }: Props) => (
  <div className="flex flex-col gap-4">
    <div className="relative h-[280px]">
      <ImageWithFallback
        alt={banner.image?.altText || 'magazine banner card'}
        className="rounded-xl"
        src={banner.image?.url || '/fallback-img-3704x2304.png'}
        url={banner.url}
        layout="fill"
        objectFit="cover"
        fallbackSrc="/fallback-img-3704x2304.png"
        sizes="(max-width: 768px) 50vw, (max-width: 1024px) 33vw, 320px"
        onClick={onClick}
        rel="noopener"
        loading={prefetch ? 'eager' : 'lazy'}
      />
    </div>

    <div className="rounded-b-2xl">
      {banner.title && <h3 className="line-clamp-2 text-regular font-bold">{banner.title}</h3>}
    </div>
  </div>
);

export default Card;
